import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { FLEX_CONTAINER_COLUMN, FLEX_ITEM, H_100, PADDING, W_100 } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { CustomElement, NAVIGATION_SERVICE, NavigationService, WebPageComponent } from "@cervval.js/client-html5-spa/navigation";
import { CjsIconFa } from "@cervval.js/client-html5-ui/src/components/icon/iconFa";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { translateHTMLReferences } from "@ehealth_tools/client-html-tools/src/tools/webcomponent.tools";
import { BookingPageName } from "../../../booking.pages";
import { I18nRelation } from "./relationPage.i18n";
@CustomElement({
    name: "relation-page",
    style: require("./relationPage.scss"),
    template: require("./relationPage.html"),
    i18n: require("./relationPage.i18n").I18n(),
    elementCssClasses: [W_100, H_100, FLEX_CONTAINER_COLUMN, FLEX_ITEM, PADDING.PY_2]
})
export class RelationPage<I18n extends I18nRelation = I18nRelation> extends WebPageComponent<I18n> {
    @TypedHtmlElements()
    public readonly components!: {
        container: HTMLDivElement,
        returnDiv: HTMLDivElement,
        returnIcon: CjsIconFa,
        returnTitle: HTMLDivElement
    };

    @Injected(NAVIGATION_SERVICE)
    private readonly navigationService!: NavigationService<BookingPageName>;

    /** @inheritdoc */
    public override init(): void {
        this.components.returnDiv.addEventListener("click", () => {
            this.navigationService.navigate("profile");
        });
        this._initIcons();
    }

    /**
     * Init icons
     */
    private _initIcons(): void {
        this.components.returnIcon.options.setAndRefreshIfChanged({
            name: "fa-chevron-left"
        });
    }

    /** @inheritdoc */
    public override refresh(): void {
        this._refreshI18n();
    }

    /**
     * Refresh i18n elements
     */
    private _refreshI18n(): void {
        translateHTMLReferences(this.components, this.i18n.html);
    }

}
